import React, { useRef } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Loading from "../../components/Loading";
import NoData from "../../components/NoData";

const NextArrow = ({ onClick }) => (
  <div
    className="absolute right-0 z-10 flex items-center justify-center w-12 h-12 text-white transform -translate-y-1/2 bg-black opacity-50 cursor-pointer top-1/2"
    onClick={onClick}
  >
    <IoIosArrowForward size={30} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    className="absolute left-0 z-10 flex items-center justify-center w-12 h-12 text-white transform -translate-y-1/2 bg-black opacity-50 cursor-pointer top-1/2"
    onClick={onClick}
  >
    <IoIosArrowBack size={30} />
  </div>
);

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  // beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  // responsive: [
  //   {
  //     breakpoint: 3000,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //     },
  //   },
  //   {
  //     breakpoint: 1024,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //     },
  //   },

  //   {
  //     breakpoint: 630,
  //     settings: {
  //       slidesToShow: 2,
  //       slidesToScroll: 1,
  //     },
  //   },

  //   {
  //     breakpoint: 425,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //     },
  //   },
  // ],
};

const Banner = () => {
  const sliderRef = useRef(null);

  const landingBanner = useSelector((state) => state.banner.banners);

  const loading = useSelector((state) => state.banner.isLoading);

  return (
    <>
      {loading ? (
        <div className="flex justify-center h-[calc(100vh-4rem)] items-center">
          <Loading />
        </div>
      ) : (
        <div className="mb-gap">
          {landingBanner?.length ? (
            <div>
              {landingBanner?.length > 1 ? (
                <Slider adaptiveHeight={true} ref={sliderRef} {...settings}>
                  {landingBanner?.map((b, index) => (
                    <div>
                      <div key={index}>
                        <Link to="/products">
                          <img
                            alt=""
                            // TODO:// replaced image src with static image
                            src={b?.image?.url}
                            // src="https://thebetterappliances.com/wp-content/uploads/2024/12/Oven-Website-Banner.jpg"

                            className="object-center w-full aspect-[16/4]"
                          />
                        </Link>
                      </div>
                    </div>
                  ))}
                </Slider>
              ) : (
                <>
                  {landingBanner?.map((b, index) => (
                    <div key={index}>
                      <Link to="/products">
                        <img
                          alt=""
                          // TODO:// replaced image src with static image
                          src={b?.image?.url}
                          // src="https://thebetterappliances.com/wp-content/uploads/2024/12/Oven-Website-Banner.jpg"
                          className="object-top object-cover w-full aspect-[16/6]"
                        />
                      </Link>
                    </div>
                  ))}
                </>
              )}
            </div>
          ) : (
            <NoData />
          )}
        </div>
      )}
    </>
  );
};

export default Banner;
